<template>
  <v-container
    style="margin: 0px; padding: 0px; max-width: 100%; vertical-align: top"
  >
    <v-card>
      <v-card-title>
        <ent-workflow-nav-bar :args="navConfig" :buttonclick.sync="navbuttons">
        </ent-workflow-nav-bar>
      </v-card-title>
      <v-card-text>
        <v-row dense class="mt-10">
            <server-iterator></server-iterator>
            <v-col cols="4">
        <v-card><v-card-title>Immature Batch Naming</v-card-title></v-card>
            </v-col>
            <v-col cols="4">
        <v-card><v-card-title>Harvest Naming</v-card-title> </v-card>
            </v-col>
              <v-col cols="4">
        <v-card><v-card-title>FOO1</v-card-title> </v-card>
            </v-col>
              <v-col cols="4">
        <v-card><v-card-title>FOO1</v-card-title> </v-card>
            </v-col>
              <v-col cols="4">
        <v-card><v-card-title>FOO1</v-card-title> </v-card>
            </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
  import { sync } from "vuex-pathify";
  import EntWorkflowNavBar from "@/../../library/view/EntWorkflowNavBar.vue";
  import ServerIterator from '@/../../coreui/components/ServerIterator.vue'
  import navbuttonUtils from "@/../../library/mixins/navbuttons.js"
  export default {
    components: {
      EntWorkflowNavBar,
      ServerIterator
    },
    mixins:[navbuttonUtils],
    props: ["args"],
    data: () => ({
      navConfig: {},
      navbuttons: null,
      hasClose: true
    }),
    computed: {
      userlang: sync("misc/language"),
      phrases: sync("misc/phraseMap"),
    },
    watch: {
      navbuttons() {
        console.log(`Buttons Changed`);
        console.log("updated button state", this.navbuttons);
        this.processButtonClick(this.navbuttons.click);
      },
    },
    methods: {
      checkHelp() {
        return false;
        //if (this.$refs.main_section === undefined) return false;
        //let helpExists = this.$refs.main_section.getHelp();
        //if (check.isUndefined(helpExists) || !helpExists) return false;
        //return true;
      }
    },
    mounted() {
      this.configureNavigation();
    },
  };
</script>
